'use strict';
import angular from 'angular';
import $ from 'jquery';
import _ from 'lodash';

import integrationHtmlUrl from '../views/integration.html';
import mappingFormHtmlUrl from '../views/mappingForm.html';
import ioActivityLogTreeHtmlUrl from '../views/ioActivityLogTree.html';

angular.module('integrations.directives', [])

    .directive('integration', function() {
        return {
            restrict: 'E',
            scope: {
                integrationData: '<',
                deleteFn: '&',
                editFn: '&',
                exportFn: '&',
                key: '<',
                toggleFn: '&',
                disablebuts:'<'
            },
            replace: true,
            templateUrl: integrationHtmlUrl,
            controller: function($scope, $state) {
                $scope.isActive = parseInt($scope.integrationData.active) ? true : false;
                for (var key in $scope.integrationData) {
                    if ($scope.integrationData.hasOwnProperty(key)) {
                        $scope[key] = $scope.integrationData[key];
                    }
                }
                $scope.fontSize = {};
                switch ($scope.integrationData.type_id) {
                    case '4':
                    case '5':
                        $scope.serviceIcon = "alphabet-u-w";
                        $scope.customStyles = {
                            "font-size": "100px",
                            "top": "48px"
                        }
                        break;
                    case '3':
                        $scope.serviceIcon = "serviceicon-salesforce";
                        break;
                    case '2':
                        $scope.serviceIcon = "icon-desktop";
                        $scope.customStyles = {
                            "font-size": "100px"
                        }
                        break;
                    default:
                        $scope.serviceIcon = "serviceicon-default";
                }

                $scope.edit = function() {
                    $scope.editFn({ data: $scope.integrationData });
                };
                $scope.export = function() {
                    $scope.exportFn({ data: $scope.integrationData });
                };
                $scope.delete = function() {
                    $scope.deleteFn({ data: $scope.integrationData })
                }

                $scope.updateStatus = function(isActive) {
                    $scope.integrationData.active = $scope.isActive ? 1 : 0;
                    $scope.toggleFn({ data: $scope.integrationData });
                }

                $scope.navigate = function(id) {
                    var type;
                    switch (parseInt($scope.integrationData.type_id)) {
                        case 2:
                            type = 'file';
                            break;
                        case 3:
                            type = 'salesforce';
                            break;
                        case 4:
                            type = 'webhookPublish';
                            break;
                        case 5:
                            type = 'webhookConsume';
                            break;
                        default:
                            type = 'custom';
                            break;
                    }
                    $state.go('integrations.mappings', {
                        "id": id,
                        "type": type
                    });
                }
            }
        }
    })

    .directive('mappingForm', ['IntegrationsService', '$ioAlert','$rootScope','$confirm', '$state', 'FormService', function(IntegrationsService, $ioAlert, $rs, $confirm, $state, FormService) {
        return {
            restrict: 'E',
            scope: {
                templates: '=',
                mappingType: '<',
                mapref: '=',
                dtaTypes: '=',
                integrationId: '=',
                lookupTypes: '=',
                webhookConsume: "="
            },
            templateUrl: mappingFormHtmlUrl,
            controller: function($scope) {
                $scope.new = {};
                $scope.tooltip = {};
                $scope.tooltip.mappings = 'Source field from integration file or api field to be mapped to order or product fields.'
                $scope.tooltip.fieldType = 'Datatype expected for integration source field.';
                $scope.tooltip.lookupType = 'Lookup Type associated with order or product field that will be matched to source list of values.';
                $scope.tooltip.required = 'Field is required on integration source.';
                $scope.templateBackups = [];
                $scope.showNewTemplate = false;
                $scope.disableBtnAction = false;

                $scope.addTemplate = function() {
                    const paramsObj = $scope.new;
                    if ($scope.mappingType.name != 'Client') {
                        paramsObj[($scope.mappingType.name === 'Order' ? 'cluster' : _.lowerCase($scope.mappingType.name)) + 'Id'] = $scope.mappingType.id;
                        paramsObj.required = paramsObj.isRequired ? 1 : 0;
                        paramsObj.fieldId = paramsObj.field_id;
                        paramsObj.is_flight_field = paramsObj.isFlightField ? 1 : 0;
                    }
                    paramsObj['integrationId'] = $scope.integrationId;
                    IntegrationsService[$scope.mappingType.name + 'IntegrationTemplate']('POST', paramsObj).then(function(data) {
                        if (!data.hasOwnProperty('errors')) {
                            $scope.templates.push(data[$scope.mappingType.name + 'IntegrationTemplate']);
                            $scope.new = {};
                            $scope.showNewTemplate = false;
                            $ioAlert.show('', 'Mapping template successfully added.', 'success');
                        } else {
                            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                        }
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    })
                }

                $scope.addNewTemplate = function() {
                    $scope.showNewTemplate = true;
                }

                $scope.editTemplate = function(template) {
                    template.editing = true;
                    var templateObj = angular.copy(template);
                    $scope.templateBackups.push(templateObj);
                }

                $scope.saveTemplate = function(template) {
                    let paramsObj = angular.copy(template);
                    paramsObj.integrationId = paramsObj.integration_id;
                    if ($scope.mappingType.name != 'Client') {
                        paramsObj.productId = paramsObj.product_id;

                        // parse and distiguish product field id and flight field id
                        if ($scope.mappingType.name == 'Product') {
                            paramsObj.fieldId = paramsObj.field_id.slice(0, -1);
                        } else {
                            paramsObj.fieldId = paramsObj.field_id;
                        }

                        paramsObj.lookupTypeId = paramsObj.lookup_type_id;

                        if (paramsObj.cluster_id) {
                            paramsObj.clusterId = paramsObj.cluster_id;
                        }

                        paramsObj.required = paramsObj.isRequired ? 1 : 0;
                        paramsObj.is_flight_field = paramsObj.isFlightField ? 1 : 0;
                        delete paramsObj.isRequired;
                        delete paramsObj.isFlightField;
                    } else {
                        paramsObj.fieldName = template.field_name;
                        paramsObj.lookupTypeId = paramsObj.lookup_type_id;
                        delete paramsObj.field_name;
                        delete paramsObj.lookup_type_id;
                    }
                    IntegrationsService[$scope.mappingType.name + 'IntegrationTemplate']('PUT', paramsObj).then(function(data) {
                        if (!data.hasOwnProperty('errors')) {
                            $scope.resetTemplate[$scope.mappingType.name + 'IntegrationTemplate'];
                            template.editing = false;
                            $ioAlert.show('', 'Mapping template successfully saved.', 'success');
                        } else {
                            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                            $scope.resetTemplate(template);
                        }
                        template.editing = false;
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                }

                $scope.cancelTemplate = function(template) {
                    $scope.resetTemplate(template);
                    template.editing = false;
                }

                $scope.clearTemplate = function() {
                    $scope.new = {};
                    $scope.showNewTemplate = false;
                }

                $scope.resetTemplate = function(template, templateData) {
                    var templateObj = null;
                    if (templateData) {
                        templateObj = templateData;
                    } else {
                        templateObj = _.find($scope.templateBackups, { id: template.id });
                    }
                    if (templateObj) {
                        template.parameter = templateObj.parameter;
                        template.field_id = templateObj.field_id;
                        template.datatype = templateObj.datatype;
                        template.lookup_type_id = templateObj.lookup_type_id;
                        template.required = templateObj.required;
                        template.is_flight_field = templateObj.is_flight_field;
                        $scope.templateBackups.splice($scope.templateBackups.indexOf(templateObj), 1);
                    }
                }

                $scope.changeInternalField = function(template) {
                    if (template && $scope.mappingType.name == 'Product') {
                        template.isFlightField = template.field_id.slice(-1) === 'f' ? true : false;
                    }
                }
                 /*
                * Handle get instance lock configuration
                */
               var getInstanceLockConfig = function() {
                FormService.getInstanceLockConfig().then(function(data) {
                    if(data.instanceLocked) {
                        $scope.disableBtnAction = true;
                    } else {
                        $scope.disableBtnAction = false;
                    }
               }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            }
            getInstanceLockConfig();

                $scope.deleteTemplate = function(index) {
                    IntegrationsService[$scope.mappingType.name + 'IntegrationTemplate']('DELETE', { id: $scope.templates[index].id }).then(function(data) {
                        if (!data.hasOwnProperty('errors')) {
                            $scope.templates.splice(index, 1);
                            $ioAlert.show('', 'Mapping template successfully deleted.', 'success');
                        } else {
                            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                        }
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    })
                }
                
                var integrationsSelector = $rs.$on('LoadIntegrations', function(event, data) {
                    if(data && data.type.id == $scope.mappingType.id) {
                        
                        if(data.initialTemplate) {
                            $scope.showNewTemplate = true;
                        }
                        
                        if($scope.showNewTemplate && !_.isEmpty($scope.new)) {
                            $confirm.open({
                                size: 'sm',
                                text: 'Are you sure you want to leave without saving your changes?'
                            }).then(function(success) {
                                $state.go("integrations");
                            }, function() {
                            });
                        } else{
                            $state.go("integrations");
                        }
                    }
                });

                $scope.$on('$destroy', function() {
                    integrationsSelector();
                });
            },
        }
    }])
    .directive('ioActivityLogTree', ['$timeout', '$rootScope', function($timeout, $rs) {
        return {
            restrict: 'EA',
            scope: {
                "activityLog": "="
            },
            templateUrl: ioActivityLogTreeHtmlUrl,
            link: function(scope, element, attr) {
                scope.isTreeShow = false;
                scope.isObj = function(item) {
                    return angular.isObject(item);
                }
                scope.isArray = function(item) {
                    return angular.isArray(item);
                }
                $.fn.extend({
                    treed: function(o) {

                        var openedClass = 'glyphicon-folder-open';
                        var closedClass = 'glyphicon-folder-close';
                        var activityIconClass = '';
                        if (scope.activityLog && scope.activityLog.activity && scope.activityLog.activity.errors) {
                            activityIconClass = 'icon_failure';
                        } else {
                            activityIconClass = 'icon_success';
                        }

                        if (typeof o != 'undefined') {
                            if (typeof o.openedClass != 'undefined') {
                                openedClass = o.openedClass;
                            }
                            if (typeof o.closedClass != 'undefined') {
                                closedClass = o.closedClass;
                            }
                        };

                        //initialize each of the top levels
                        var tree = $(this);
                        tree.addClass("io-tree");
                        tree.find('li').not(".branch").has("ul").each(function() {
                            var branch = $(this); //li with children ul
                            branch.prepend("<i class='indicator glyphicon " + closedClass + " " + activityIconClass + "'></i>");
                            branch.addClass('branch');
                            branch.on('click', function(e) {
                                if (this == e.target) {
                                    var icon = $(this).children('i:first');
                                    icon.toggleClass(openedClass + " " + closedClass);
                                    $(this).children().children().toggle();
                                }
                            })
                            branch.children().children().toggle();
                        });
                        //fire event from the dynamically added icon
                        tree.find('.branch .indicator').not(".isBined").each(function() {
                            $(this).addClass("isBined");
                            $(this).on('click', function() {
                                $(this).closest('li').click();
                            });
                        });
                        //fire event to open branch if the li contains an anchor instead of text
                        tree.find('.branch>a').each(function() {
                            $(this).on('click', function(e) {
                                $(this).closest('li').click();
                                e.preventDefault();
                            });
                        });
                        //fire event to open branch if the li contains a button instead of text
                        tree.find('.branch>button').each(function() {
                            $(this).on('click', function(e) {
                                $(this).closest('li').click();
                                e.preventDefault();
                            });
                        });
                    }
                });

                var displayTree = function() {
                    //Checking for errors type for string for old object. API has to support backward compatability
                    if (scope.activityLog && scope.activityLog.activity && scope.activityLog.activity.errors && typeof scope.activityLog.activity.errors == 'string') {
                        scope.isNewObject = false;
                    } else {
                        scope.isNewObject = true;
                    }
                    $timeout(function() {
                        angular.element(element).find(".treed").treed();
                        scope.isTreeShow = true;
                    });
                };

                displayTree();

                var activitySelector = $rs.$on('ActivityLoaded', function(event, args) {
                    displayTree();
                });

                scope.$on('$destroy', function() {
                    activitySelector();
                });
            }
        }
    }])